import { action, computed, makeObservable, observable } from "mobx";
import type { Stores } from "../core/stores";

export enum DbInfoType {
  Add = "add",
  Get = "get",
  Set = "set",
  Update = "update",
  WatchAdded = "watch_added",
  WatchRemoved = "watch_removed",
  WatchItem = "watch_item",
}

export type DbInfo = {
  type: DbInfoType;
  database: string;
  uid: string;
};

export default class DevsStore {
  @observable stats: DbInfo[] = [];

  constructor(protected stores: Stores) {
    makeObservable(this);
  }

  @observable gotError: Error | undefined;

  @action setGotError(error: Error | undefined) {
    this.gotError = error;
  }

  @action clearStats() {
    this.stats = [];
  }

  @action addDbStats(type: DbInfoType, database: string, uid: string) {
    this.stats.push({ type, database, uid });
  }

  @computed get adds() {
    return this.stats.filter((s) => s.type === DbInfoType.Add).length;
  }

  @computed get gets() {
    return this.stats.filter((s) => s.type === DbInfoType.Get).length;
  }

  @computed get sets() {
    return this.stats.filter((s) => s.type === DbInfoType.Set).length;
  }

  @computed get updates() {
    return this.stats.filter((s) => s.type === DbInfoType.Update).length;
  }

  @computed get watchItems() {
    return this.stats.filter((s) => s.type === DbInfoType.WatchItem).length;
  }

  @computed get watchesActive() {
    return (
      this.stats.filter((s) => s.type === DbInfoType.WatchAdded).length -
      this.stats.filter((s) => s.type === DbInfoType.WatchRemoved).length
    );
  }
}
